import General from "../views/users/general";
import Groups from "../views/users/groups";
import Access from "../views/users/access";

import PersonIcon from "../assets/icons/man.svg";
import PersonHoverIcon from "../assets/icons/manHover.svg";
import TeamIcon from "../assets/icons/team.svg";
import TeamHoverIcon from "../assets/icons/team-hover.svg";
import AccessSecIcon from "../assets/icons/access-security.svg";
import AccessSecHoverIcon from "../assets/icons/access-security-hover.svg";

const routesUsers = [
    {
        path: "/general",
        name: "Geral",
        icon: PersonIcon,
        iconHover: PersonHoverIcon,
        layout: "/users",
        component: General,
        redirect: false,
    },

    {
        path: "/groups",
        name: "Grupos",
        icon: TeamIcon,
        iconHover: TeamHoverIcon,
        layout: "/users",
        component: Groups,
        redirect: false,
    },

    {
        path: "/access",
        name: "Acessos",
        icon: AccessSecIcon,
        iconHover: AccessSecHoverIcon,
        layout: "/users",
        component: Access,
        redirect: false,
    },
]

export default routesUsers;